import styled from 'styled-components';

const ShoppingCartSummaryPointsStyled = styled.div`
  .ShoppingCartSummaryPoints {
  }
`;

export { ShoppingCartSummaryPointsStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
